@if (artifacts.panelOpen() && artifacts.activeArtifact(); as artifact) {
  <section class="report-panel" role="complementary" aria-label="Report panel">

    <header class="report-panel__header">
      <div class="report-panel__title">
        <i class="pi {{ artifact.icon || 'pi-file' }}" aria-hidden="true"></i>
        <span class="report-panel__title-text" [title]="artifact.title">{{ artifact.title }}</span>
      </div>

      <div class="report-panel__actions">
        @if (artifact.fileUrl) {
          <button type="button" class="report-panel__btn"
            title="Open in new tab" aria-label="Open in new tab"
            (click)="onOpenNewTab()">
            <i class="pi pi-external-link" aria-hidden="true"></i>
          </button>
          <button type="button" class="report-panel__btn"
            title="Download" aria-label="Download"
            (click)="onDownload()">
            <i class="pi pi-download" aria-hidden="true"></i>
          </button>
        }
        <button type="button" class="report-panel__btn report-panel__btn--close"
          title="Close panel" aria-label="Close panel"
          (click)="onClose()">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </header>

    <div class="report-panel__body">
      <!-- track by artifact.id so switching to a different report destroys and
           recreates the renderer (fresh iframe), instead of reusing one instance
           that may not reload — same id just updates inputs, no flicker. -->
      @for (a of [artifact]; track a.id) {
        <ng-container
          *ngComponentOutlet="rendererFor(a.type); inputs: { artifact: a }">
        </ng-container>
      }
    </div>

    <!-- Discovery cross-link: scheduled agents' reports are archived in the
         Workspace library (this chat report itself stays with the session). -->
    <footer class="report-panel__foot">
      <a routerLink="/workspace" class="report-panel__lib-link" (click)="onClose()">
        <i class="pi pi-folder-open" aria-hidden="true"></i>
        Browse all agent reports in Workspace
        <i class="pi pi-arrow-right" aria-hidden="true"></i>
      </a>
    </footer>
  </section>
}
